/**
 * Formats a post's updated date for meta lines.
 * @param iso - ISO date string
 * @param month - "short" (Aug 17, 2025) or "long" (August 17, 2025)
 * @returns the formatted date
 */
export function formatUpdatedDate(iso: string, month: "short" | "long"): string {
  return new Date(iso).toLocaleDateString("en-US", { year: "numeric", month, day: "numeric" });
}
